export const LOAD_QUIZ_BY_ID   = 'LOAD_QUIZ_BY_ID'
export const LOAD_QUIZ_ERROR   = 'LOAD_QUIZ_ERROR'

export const CHECK_SOLUTION   = 'CHECK_SOLUTION'
